exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.VueTables__sort-icon.project_manager_page{\n    margin-right:50% !important;\n}\n", ""]);

// exports
